import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { propBool, propId, } from '../../../../../../../helpers/custom-prop-types';
const RfpOneBackLink = (props) => {
    const { id, isPreview } = props;
    return (_jsx("div", Object.assign({ className: 'back_link' }, { children: _jsx(DynamicLink, Object.assign({ className: 'back_value', noLinkElement: isPreview ? 'span' : undefined, to: `/project/client/${id}/interview/view` }, { children: _jsx("span", Object.assign({ className: 'back_text' }, { children: "\u63D0\u6848\u4E00\u89A7\u3078\u623B\u308B" })) })) })));
};
RfpOneBackLink.propTypes = {
    id: propId().isRequired,
    isPreview: propBool().isRequired,
};
export default RfpOneBackLink;
